import { z } from 'zod';
import {
  AWS_STS_EXTERNAL_ID_MAX_LENGTH,
  AWS_STS_EXTERNAL_ID_MIN_LENGTH,
} from './aws.constants';
import { AwsStsExternalIdRegex } from './aws-patterns.constants';

export const AwsStsExternalIdSchema = z
  .string()
  .trim()
  .min(AWS_STS_EXTERNAL_ID_MIN_LENGTH)
  .max(AWS_STS_EXTERNAL_ID_MAX_LENGTH)
  .regex(AwsStsExternalIdRegex, {
    error:
      'External ID must be 2–1224 characters and use letters, numbers, or = , . @ : / - _',
  });

export const OptionalAwsStsExternalIdSchema = z
  .union([AwsStsExternalIdSchema, z.literal('')])
  .optional();
